export const testIds = {
  root: 'Pagination_Root',
  navButtonFirst: 'Pagination_NavButton_First',
  navButtonLast: 'Pagination_NavButton_Last',
  navButtonPrev: 'Pagination_NavButton_Prev',
  navButtonNext: 'Pagination_NavButton_Next',
};

export const collapseAlignmentMap = {
  left: 'flex-start',
  center: 'center',
  spread: 'space-between',
  right: 'flex-end',
};

export const PaginationMode = {
  Pages: 'pages',
  Arrows: 'arrows',
  Input: 'input',
} as const;

export const PaginationAlignment = {
  Left: 'left',
  Center: 'center',
  Spread: 'spread',
  Right: 'right',
} as const;

export const justifiedAlignmentCss = {
  '--navigation-buttons-flex-grow': 1,
  '--navigation-buttons-display': 'flex',
  '--previous-button-justify-content': 'flex-start',
  '--next-button-justify-content': 'flex-end',
};

export const alignmentCss = {
  '--navigation-buttons-flex-grow': 'unset',
  '--navigation-buttons-display': 'unset',
  '--previous-button-justify-justify-content': 'unset',
  '--next-button-justify-justify-content': 'unset',
};

export const currentPageVisuallyHiddenCss = {
  '--page-position': 'absolute',
  '--page-width': '1px',
  '--page-height': '1px',
  '--page-margin': 0,
  '--page-overflow': 'hidden',
  '--page-clip': 'rect(0, 0, 0, 0)',
  '--page-border': 0,
  '--page-pointer-events': 'none',
  '--page-padding': 0,
  '--page-min-width': 0,
  '--previous-button-inline-margin': 'calc(var(--content-gap) / 2)',
  '--next-button-inline-margin': 'calc(var(--content-gap) / 2)',
};

export const currentPageDisplayedCss = {
  '--previous-button-inline-margin': 'var(--content-gap)',
  '--next-button-inline-margin': 'var(--content-gap)',
  '--page-padding':
    'var(--page-vertical-padding) var(--page-horizontal-padding)',
  '--page-min-width': '2ch',
  '--page-position': 'unset',
  '--page-width': 'unset',
  '--page-height': 'unset',
  '--page-margin': 'unset',
  '--page-overflow': 'unset',
  '--page-clip': 'unset',
  '--page-border': 'unset',
  '--page-pointer-events': 'unset',
};
